import * as React from 'react'

interface StateToProps {
    className: string
}

export class Ribbon extends React.PureComponent<StateToProps> {

    render () {
        var {className} = this.props;
        return (<div className={className}></div>);
    }
}


// WEBPACK FOOTER //
// ./src/fragments/Ribbon.tsx